import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";
const num = (v) => (v === "" || v === null || v === undefined ? null : Number(String(v).replace(",", ".")));

export function CmiDefaults() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/agency/cmi-settings").then(({ data }) => setS({
      pct: data.default_commission_pct ?? "", months: data.default_duration_months ?? "", excl: !!data.default_exclusive,
      cpcv: data.default_pay_cpcv_pct ?? "", deed: data.default_pay_deed_pct ?? "",
    })).catch(() => {});
  }, []);
  if (!s) return null;
  const save = async () => {
    try {
      await api.put("/agency/cmi-settings", { default_commission_pct: num(s.pct), default_duration_months: num(s.months), default_exclusive: s.excl,
        default_pay_cpcv_pct: num(s.cpcv), default_pay_deed_pct: num(s.deed) });
      toast.success("Valores por defeito guardados");
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  const f = (k, label, unit, testid) => (
    <label className="flex items-center gap-2 text-sm text-slate-700">{label}
      <Input value={s[k]} onChange={(e) => setS({ ...s, [k]: e.target.value })} className="w-20 h-9" data-testid={testid} />{unit}
    </label>
  );
  return (
    <div className={card} data-testid="cmi-defaults-card">
      <h3 className="font-heading text-lg text-ec-green">Valores por defeito do contrato de mediação</h3>
      <p className="text-sm text-slate-500 mt-1">Usados nas angariações criadas pelo WhatsApp (e como sugestão nas outras).</p>
      <div className="mt-4 flex flex-wrap gap-x-6 gap-y-3">
        {f("pct", "Comissão", "%", "cmi-default-pct")}
        {f("months", "Duração", "meses", "cmi-default-months")}
        {f("cpcv", "No CPCV", "%", "cmi-default-cpcv")}
        {f("deed", "Na escritura", "%", "cmi-default-deed")}
        <label className="flex items-center gap-2 text-sm text-slate-700"><Switch checked={s.excl} onCheckedChange={(v) => setS({ ...s, excl: v })} data-testid="cmi-default-exclusive" /> Em exclusivo</label>
      </div>
      <button onClick={save} className="mt-4 px-4 h-9 rounded-lg bg-ec-green text-white text-sm font-semibold hover:bg-ec-greenDark transition-colors" data-testid="cmi-defaults-save">Guardar</button>
    </div>
  );
}
